import type { App } from 'vue'
import { hasPermission, permission } from './permission'

export function loadDirectives(app: App) {
  app.config.globalProperties.$permission = hasPermission
  app.directive('permission', permission)
}
